"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BaseUri = require("./Support/BaseUri");
var Request = require("./Support/Request");
function getColorFavorites() {
    var url = BaseUri.compose()
        .segment('colorfavorites')
        .toString();
    return Request.getJson(url);
}
exports.getColorFavorites = getColorFavorites;
function saveColorFavorites(colorFavorites) {
    var url = BaseUri.compose('colorfavorites', 'save')
        .toString();
    return Request.postJsonOk(url, colorFavorites);
}
exports.saveColorFavorites = saveColorFavorites;
